import * as types from "../constants/actionTypes";

import {addNotification as notify} from 'reapop';
import * as fogActions from "../graphql/actions/fog";
import * as utils from "../utils/fog";
import l10n from "../l10n/localization";
import * as creationActions from "./creation";
import * as ajaxRoutes from "../constants/ajaxRoutes";
import * as authHandler from "../utils/authHandler";

export function setFogDisplayAllFilter(value) {
    return dispatch => {
        dispatch({
            type: types.TOGGLE_DISPLAY_ALL_FILTER,
            payload: value,
        });

        if (value === true) {
            // ALL FOGS
            dispatch(fetchFogs(true, true));
        } else {
            // ONLY ACTIVE FOGS
            dispatch(fetchFogs(true));
        }
    };
}

export function fetchFogs(force = false, displayAllFogs = false) {
	return dispatch => {
		dispatch(loading());

        fogActions.getFogs(
            function(response) {
                dispatch(receiveFogs(utils.buildFogTable(response.data.fogs)));
            },
            function(error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            force,
            displayAllFogs
        );
	}
}

export function duplicateFog(fogID) {
    return dispatch => {
        let url = ajaxRoutes.API_ROUTE + "/fog/duplicate/"+fogID;
        let headers = new Headers({"X-Authorization": 'Bearer ' + authHandler.getToken()});
        dispatch(duplicatingFog());
        fetch(url, {headers: headers})
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then(() => {
                dispatch(doneDuplicatingFog());
                dispatch(fetchFogs(true, true));
            })
            .catch((error) => {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(doneDuplicatingFog());
            });
    };
}

export function add(fog) {
    delete fog.reference;
    delete fog.documents;
    delete fog.costs;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(fog));
        fogActions.add(
            function (response) {
                dispatch(saved(response.data.createFog));
                dispatch(fetchFogs(true));
                dispatch(notify({message: l10n.messages.success, status: 'success'}));
                dispatch(creationActions.receivednewlyCreatedFog(response.data.createFog));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            fog
        );
    };
}

export function edit(fog, withRedirectToHomepage = false, fetchArchived = false) {
    let id = fog.id;
    delete fog.id;
    delete fog.__typename;
    delete fog.cargos;
    delete fog.creationDate;
    delete fog.reference;
    delete fog.invoices;
    delete fog.documents;
    delete fog.costs;

    return dispatch => {
        dispatch(loading());
        dispatch(saving(fog));
        fogActions.edit(
            function (response) {
                if (withRedirectToHomepage === true) {
                    dispatch(notify({message: l10n.messages.success, status: 'success'}));
                    document.location.href="/"
                } else {
                    dispatch(saved(response.data.editFog));
                    dispatch(fetchFogs(true, fetchArchived));
                    dispatch(notify({message: l10n.messages.success, status: 'success'}));
                }
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
                dispatch(errorSaving());
            },
            id,
			fog
        );
    };
}

export function get(id, force = false) {
    return dispatch => {
        dispatch(loading());
        fogActions.get(
            function (response) {
                dispatch(receiveFog(response.data.fog));
            },
            function (error) {
                dispatch(notify({message: error.message, status: 'error'}));
            },
            id,
            force
        );
    };
}

export function loading() {
    return {
        type: types.LOADING_FOG
    };
}

export function saving(fog) {
    return {
        type: types.SAVING_FOG,
        payload: fog
    };
}

export function saved(fog) {
    return {
        type: types.SAVED_FOG,
        payload: fog
    };
}

export function errorSaving() {
    return {
        type: types.ERROR_SAVING_FOG,
    };
}

export function receiveFogs(data) {
    return {
        type: types.RECEIVED_FOGS,
        payload: data
    };
}

export function receiveFog(fog) {
    return {
        type: types.RECEIVED_FOG,
        payload: fog
    };
}

export function duplicatingFog() {
    return {
        type: types.DUPLICATING_FOG,
    };
}

export function doneDuplicatingFog() {
    return {
        type: types.DONE_DUPLICATING_FOG,
    };
}

export function updateFormDataFog(formData = {}) {
    return {
        type: types.UPDATEDATAFORM_FOG,
        payload: {
            formData: formData
        }
    }
}

export function clearFormDataFog() {
    return {
        type: types.CLEARDATAFORM_FOG
    }
}

export function errorMessage(message) {
    return dispatch => {
        dispatch(notify({message: message, status: 'error',dismissAfter: 8000}));
    };
}


// WEBPACK FOOTER //
// ./src/actions/fog.js